var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArchive = function SvgIconArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.75a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.25 8.25a1.75 1.75 0 0 0 1.5 1.732V18a1.75 1.75 0 0 0 1.75 1.75h15A1.75 1.75 0 0 0 21.25 18V9.982a1.75 1.75 0 0 0 1.5-1.732V6A1.75 1.75 0 0 0 21 4.25H3A1.75 1.75 0 0 0 1.25 6zm2-2V8h17.5V6.25zm16 11.5V10H4.75v7.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArchive;